export default __webpack_public_path__ + "static/4-3cc38b3def6f4a64a10e66f0b36c3c0b.png";